export default __webpack_public_path__ + "static/media/No.52099b5f.svg";